<frodo-page-shell>
  <div class="home-screen-nav">
    <div class="title-container">
      <p class="title">{{ 'common.helpCenterTitle' | translate }}</p>
    </div>
  </div>
  <div class="cards-container">
    <span class="message">{{ 'common.helpCenterMessage' | translate }}</span>
  </div>
</frodo-page-shell>
